/**
 * @fileoverview Home Cube Controller Module.
 * Manages the visibility of the cube element in the homepage hero section,
 * especially handling its compatibility with specific browser versions.
 */
import {elementExists, hideCubeIfSafariNotSupported} from "../Utils";

const HomeCubeController = {
    homeCubeSelector: '.cube-hero',

    /**
     * Initializes the HomeCubeController.
     * Checks for the existence of the home cube element and handles its visibility based on browser compatibility.
     */
    init() {
        if (! elementExists(this.homeCubeSelector)) return;
        hideCubeIfSafariNotSupported(this.homeCubeSelector)
    },
}
export default HomeCubeController;